import { render, staticRenderFns } from "./WarehouseFormItemProduct.vue?vue&type=template&id=32b918ae&scoped=true"
import script from "./WarehouseFormItemProduct.vue?vue&type=script&lang=js"
export * from "./WarehouseFormItemProduct.vue?vue&type=script&lang=js"
import style0 from "./WarehouseFormItemProduct.vue?vue&type=style&index=0&id=32b918ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b918ae",
  null
  
)

export default component.exports